import { Storage } from 'aws-amplify';
import { useEffect, useState } from 'react';

const getImageFromStorage = async (imageKey) => {
  try {
    const signedURL = await Storage.get(imageKey); // get key from Storage.list
    return signedURL;
  } catch (error) {
    console.log('🚀 ~ file: AWSServices.js ~ line 8 ~ getImageFromStorage ~ error', error);
  }
  return undefined;
};

export const useStorageImage = (imageKey) => {
  const [image, setImage] = useState();

  useEffect(() => {
    const fetchImage = async () => {
      try {
        if (imageKey) {
          const signedURL = await getImageFromStorage(imageKey);
          setImage(signedURL);
        }
      } catch (error) {
        console.info(error);
      }
    };

    fetchImage();
  }, [imageKey]);

  return imageKey ? image : undefined;
};
